export default __webpack_public_path__ + "static/media/GalanoGrotesque-Medium.9b1030de.woff";